import { render } from "./ViewBatchWaitingToReceiveContainer.vue?vue&type=template&id=23f816e3"
import script from "./ViewBatchWaitingToReceiveContainer.vue?vue&type=script&lang=js"
export * from "./ViewBatchWaitingToReceiveContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__